import { InjectionToken, WritableSignal, inject, signal } from '@angular/core';

// Токен для гидрирования полностью пререндеренных страниц, служит для предотвращения показа скелетона при старте страницы
// По умолчанию true
export const IS_HYDRATE_START_PAGE: InjectionToken<WritableSignal<boolean>> = new InjectionToken<
  WritableSignal<boolean>
>('Check is hydrate start page', {
  factory: () => {
    return signal(true);
  },
});

export const setAfterHydrateStartPage: () => () => void = (): (() => void) => {
  const isHydratedStartPage: WritableSignal<boolean> = inject(IS_HYDRATE_START_PAGE);
  return () => {
    if (isHydratedStartPage()) {
      isHydratedStartPage.set(false);
    }
  };
};
